import IconBase from "./IconBase";

const GarbageCanIcon = props => (
  <IconBase data-testid="GarbageCanIcon" {...props}>
    <g fill="none" stroke="currentColor">
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 6.5h14"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.5 9.5v4M11.5 9.5v4"
      />
      <path
        strokeWidth="2"
        d="M15 6v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M13.5 6V5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v1"
      />
    </g>
  </IconBase>
);

export default GarbageCanIcon;
